(() => {
  const normalize = text => String(text).toLowerCase().replace(/[^a-z0-9]/g, '');
  function modelsIn(text) {
    let value = String(text).toLowerCase();
    const models = new Set();
    for (const [pattern, model] of [[/\ba1\s*mini\b/g,'a1mini'],[/\bh2d\s*pro\b/g,'h2dpro']]) {
      if (pattern.test(value)) models.add(model);
      value = value.replace(pattern, ' ');
    }
    for (const [pattern, model] of [[/\ba1\b/,'a1'],[/\ba2l\b/,'a2l'],[/\bp1(?:s|p)?\b/,'p1'],[/\bp2s?\b/,'p2s'],[/\bx1(?:c|e)?\b/,'x1'],[/\bx2d\b/,'x2d'],[/\bh2c\b/,'h2c'],[/\bh2d\b/,'h2d'],[/\bh2s\b/,'h2s']]) {
      if (pattern.test(value)) models.add(model);
    }
    return [...models];
  }
  function queryParts(query, model) {
    const models = [...new Set([...modelsIn(query), ...(model ? [model] : [])])];
    const words = String(query).toLowerCase().replace(/\b(?:a1\s*mini|h2d\s*pro|a1|a2l|p1s?|p1p|p2s?|x1c?|x1e|x2d|h2c|h2d|h2s)\b/g, ' ').trim().split(/\s+/).map(normalize).filter(Boolean);
    return {models, words};
  }
  function matches(base, option, query) {
    // Explicit configuration models take precedence over a broad product title.
    const optionModels = modelsIn(option);
    const models = optionModels.length ? optionModels : modelsIn(base);
    const text = normalize(base + ' ' + option);
    return query.models.every(model => models.includes(model)) && query.words.every(word => text.includes(word));
  }
  function roundState(now, rounds) {
    const index = rounds.findIndex(round => now >= round.start && now < round.end);
    if (index >= 0) return {state:'live', index, boundary:rounds[index].end};
    const next = rounds.findIndex(round => now < round.start);
    if (next >= 0) return {state:next ? 'between' : 'upcoming', index:next, boundary:rounds[next].start};
    return {state:'ended', index:rounds.length - 1, boundary:null};
  }
  if (typeof module !== 'undefined' && module.exports) module.exports = {modelsIn, queryParts, matches, roundState};
  if (typeof document === 'undefined') return;
  function updateCard(select) {
    const option = select.selectedOptions[0], card = select.closest('[data-bf-product]');
    card.querySelector('[data-bf-price]').textContent = option.dataset.price;
    const base = card.querySelector('[data-bf-base]');
    base.textContent = option.dataset.base; base.hidden = option.dataset.discounted !== 'true';
    const saving = card.querySelector('.nx-bf-save');
    if (saving) { saving.textContent = option.dataset.saving; saving.hidden = option.dataset.discounted !== 'true'; }
    card.querySelector('[data-bf-link]').href = option.dataset.url;
    const image = card.querySelector('.nx-bf-card-art img');
    if (image && option.dataset.image) { image.removeAttribute('srcset'); image.src = option.dataset.image; image.alt = card.querySelector('h3').textContent + ' — ' + option.dataset.title; }
  }
  function init() {
    document.querySelectorAll('[data-bf-select]').forEach(select => {
      if (select.dataset.ready) return;
      select.dataset.ready = 'true'; select.addEventListener('change', () => updateCard(select));
    });
    const search = document.querySelector('[data-bf-search]');
    if (search && !search.dataset.ready) {
      search.dataset.ready = 'true';
      const model = document.querySelector('[data-bf-model]'), results = document.querySelector('[data-bf-results]'), empty = document.querySelector('[data-bf-empty]');
      const records = [...document.querySelectorAll('[data-bf-product]')].map(card => {
        const select = card.querySelector('[data-bf-select]');
        const base = [card.querySelector('h3')?.textContent, ...[...card.querySelectorAll('.nx-bf-card-body > p')].map(p => p.textContent)].join(' ');
        return {card, select, base, initial:select?.value, options:select ? [...select.options].map(o => ({element:o, title:o.dataset.title || o.textContent.split(' — $')[0]})) : []};
      });
      const sections = [...document.querySelectorAll('section.nx-bf')].map(section => ({section, cards:[...section.querySelectorAll('[data-bf-product]')]})).filter(record => record.cards.length);
      function filter() {
        const query = queryParts(search.value, model.value), active = Boolean(search.value.trim() || model.value);
        let count = 0;
        records.forEach(record => {
          const options = record.options.filter(option => matches(record.base, option.title, query));
          record.options.forEach(option => { option.element.disabled = active && !options.includes(option); });
          const found = record.select ? options.length > 0 : matches(record.base, '', query);
          record.card.hidden = !found;
          if (found) count++;
          if (record.select && found) {
            const value = active ? (options.find(o => o.element.value === record.select.value) || options[0]).element.value : record.initial;
            if (record.select.value !== value) { record.select.value = value; updateCard(record.select); }
            record.card.querySelectorAll('[data-bf-option-id]').forEach(row => { row.hidden = active && !options.some(o => o.element.value === row.dataset.bfOptionId); });
          }
        });
        sections.forEach(({section,cards}) => { section.hidden = cards.every(card => card.hidden); });
        results.textContent = `${count} ${count === 1 ? results.dataset.single : results.dataset.label}`;
        empty.hidden = count > 0;
        document.querySelectorAll('[data-bf-clear]').forEach(button => { button.disabled = !active; });
      }
      let inputTimer;
      search.addEventListener('input', () => { clearTimeout(inputTimer); inputTimer = setTimeout(filter, 100); });
      model.addEventListener('change', filter);
      const clear = () => { clearTimeout(inputTimer); search.value = ''; model.value = ''; filter(); };
      document.querySelectorAll('[data-bf-clear]').forEach(button => button.addEventListener('click', () => { clear(); search.focus(); }));
      document.querySelectorAll('.nx-bf-nav a').forEach(link => link.addEventListener('click', () => {
        if (link.hash !== '#bf-filters') clear();
      }));
      filter();
    }
    const slot = document.querySelector('[data-bf-nav-slot]');
    if (slot && !slot.dataset.ready && 'IntersectionObserver' in window) {
      slot.dataset.ready = 'true'; const nav = slot.querySelector('nav'), mobile = matchMedia('(max-width:760px)');
      const observer = new IntersectionObserver(entries => {
        const pin = mobile.matches && entries[0].boundingClientRect.top < 0;
        slot.style.minHeight = pin ? `${nav.offsetHeight}px` : '';
        nav.classList.toggle('is-pinned', pin);
      });
      observer.observe(slot);
      mobile.addEventListener('change', () => { nav.classList.remove('is-pinned'); slot.style.minHeight = ''; observer.unobserve(slot); observer.observe(slot); });
    }
    document.querySelectorAll('[data-bf-flash-clock]').forEach(clock => {
      if (clock.dataset.ready) return; clock.dataset.ready = 'true';
      const items = [...clock.querySelectorAll('[data-bf-round]')];
      const rounds = items.map(item => ({start:Date.parse(item.dataset.start),end:Date.parse(item.dataset.end)}));
      const origin = performance.now(), serverTime = Number(clock.dataset.now) * 1000;
      let previous = roundState(serverTime, rounds).state;
      const formatter = new Intl.DateTimeFormat(document.documentElement.lang || 'en', {timeZone:'America/Vancouver',month:'short',day:'numeric',hour:'numeric',minute:'2-digit',timeZoneName:'short'});
      const put = (element, text) => { if (element.textContent !== text) element.textContent = text; };
      function tick() {
        const now = serverTime + performance.now() - origin, current = roundState(now, rounds);
        const stateChanged = current.state !== previous;
        clock.dataset.state = current.state;
        put(clock.querySelector('[data-bf-flash-title]'), clock.dataset[current.state]);
        clock.querySelector('[data-bf-flash-badge]').hidden = current.state !== 'live';
        const detail = clock.querySelector('[data-bf-flash-detail]');
        put(detail, current.boundary ? `${current.state === 'live' ? clock.dataset.ends : clock.dataset.starts} ${formatter.format(current.boundary)}` : clock.dataset.finished);
        items.forEach((item, index) => {
          const state = now >= rounds[index].end ? 'ended' : current.state === 'live' && index === current.index ? 'live' : 'upcoming';
          item.dataset.state = state; put(item.querySelector('[data-bf-round-label]'), clock.dataset['round' + state[0].toUpperCase() + state.slice(1)]);
        });
        if (stateChanged) {
          document.querySelectorAll('[data-bf-refresh]').forEach(notice => { notice.hidden = false; });
          document.querySelectorAll('[data-bf-product]').forEach(card => { card.classList.add('nx-bf-price-refresh'); const select = card.querySelector('select'); if (select) select.disabled = true; });
        }
        previous = current.state;
      }
      clock.querySelector('[data-bf-refresh-button]').addEventListener('click', () => location.reload());
      tick(); setInterval(() => { if (!document.hidden) tick(); }, 1000);
      document.addEventListener('visibilitychange', () => { if (!document.hidden) tick(); });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();

document.addEventListener('keydown',e=>{if(e.key==='Escape'){const menu=document.querySelector('.nx-us-filament-menu[open]');if(menu){menu.open=false;menu.querySelector('summary').focus();}}});document.addEventListener('click',e=>{const menu=document.querySelector('.nx-us-filament-menu[open]');if(menu&&!menu.contains(e.target))menu.open=false;});
